import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/设置.svg';
import _imports_1 from '@/assets/blue.jpg';
import _imports_2 from '@/assets/org.jpg';
import _imports_3 from '@/assets/rise.png';
import _imports_4 from '@/assets/fall.png';
import _imports_5 from '@/assets/status_blue.svg';
import _imports_6 from '@/assets/status_green.svg';
import _imports_7 from '@/assets/status.svg';
const _withScopeId = n => (_pushScopeId("data-v-a1bdd62e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "main"
};
const _hoisted_2 = {
  class: "box"
};
const _hoisted_3 = {
  style: {
    "display": "flex",
    "justify-content": "space-between"
  }
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("div", {
  class: "box_title"
}, "常用功能")], -1));
const _hoisted_5 = {
  class: "box_sezUse"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("img", {
  style: {
    "vertical-align": "middle"
  },
  src: _imports_0
})], -1));
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  style: {
    "margin-bottom": "5px"
  }
};
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  class: "box"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "box_title"
}, "待办事项", -1));
const _hoisted_12 = {
  style: {
    "display": "flex",
    "justify-content": "space-between"
  }
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
}, null, -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2
}, null, -1));
const _hoisted_15 = {
  class: "box",
  style: {
    "height": "180px"
  }
};
const _hoisted_16 = {
  style: {
    "display": "flex",
    "justify-content": "space-between"
  }
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("div", {
  class: "box_title"
}, "统计数据")], -1));
const _hoisted_18 = {
  class: "box_date"
};
const _hoisted_19 = {
  class: "statistic-card"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "display": "inline-flex",
    "align-items": "center",
    "font-size": "14px"
  }
}, " 骑行金额(元) ", -1));
const _hoisted_21 = {
  class: "statistic-footer"
};
const _hoisted_22 = {
  class: "footer-item"
};
const _hoisted_23 = {
  key: 0
};
const _hoisted_24 = {
  key: 1
};
const _hoisted_25 = {
  key: 2
};
const _hoisted_26 = {
  key: 0,
  src: _imports_3
};
const _hoisted_27 = {
  key: 1,
  src: _imports_4
};
const _hoisted_28 = {
  class: "statistic-card"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "display": "inline-flex",
    "align-items": "center",
    "font-size": "14px"
  }
}, " 骑行订单(单) ", -1));
const _hoisted_30 = {
  class: "statistic-footer"
};
const _hoisted_31 = {
  class: "footer-item"
};
const _hoisted_32 = {
  key: 0
};
const _hoisted_33 = {
  key: 1
};
const _hoisted_34 = {
  key: 2
};
const _hoisted_35 = {
  key: 0,
  src: _imports_3
};
const _hoisted_36 = {
  key: 1,
  src: _imports_4
};
const _hoisted_37 = {
  class: "statistic-card"
};
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "display": "inline-flex",
    "align-items": "center",
    "font-size": "14px"
  }
}, " 新增用户(个) ", -1));
const _hoisted_39 = {
  class: "statistic-footer"
};
const _hoisted_40 = {
  class: "footer-item"
};
const _hoisted_41 = {
  key: 0
};
const _hoisted_42 = {
  key: 1
};
const _hoisted_43 = {
  key: 2
};
const _hoisted_44 = {
  key: 0,
  src: _imports_3
};
const _hoisted_45 = {
  key: 1,
  src: _imports_4
};
const _hoisted_46 = {
  class: "statistic-card"
};
const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "display": "inline-flex",
    "align-items": "center",
    "font-size": "14px"
  }
}, " 新增运维任务(个) ", -1));
const _hoisted_48 = {
  class: "statistic-footer"
};
const _hoisted_49 = {
  class: "footer-item"
};
const _hoisted_50 = {
  key: 0
};
const _hoisted_51 = {
  key: 1
};
const _hoisted_52 = {
  key: 2
};
const _hoisted_53 = {
  key: 0,
  src: _imports_3
};
const _hoisted_54 = {
  key: 1,
  src: _imports_4
};
const _hoisted_55 = {
  class: "box",
  style: {
    "height": "310px"
  }
};
const _hoisted_56 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "box_title"
}, "运维任务处理超时", -1));
const _hoisted_57 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_58 = {
  key: 0,
  src: _imports_5
};
const _hoisted_59 = {
  key: 1,
  src: _imports_6
};
const _hoisted_60 = {
  style: {
    "margin-left": "10px"
  }
};
const _hoisted_61 = {
  class: "box",
  style: {
    "height": "310px"
  }
};
const _hoisted_62 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "box_title"
}, "运维人员", -1));
const _hoisted_63 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1));
const _hoisted_64 = {
  style: {
    "display": "flex",
    "justify-content": "start"
  }
};
const _hoisted_65 = {
  class: "box_imgt"
};
const _hoisted_66 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
}, null, -1));
const _hoisted_67 = {
  class: "box_imgt"
};
const _hoisted_68 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
}, null, -1));
const _hoisted_69 = {
  class: "box_imgt"
};
const _hoisted_70 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2
}, null, -1));
const _hoisted_71 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_72 = {
  key: 0,
  src: _imports_5
};
const _hoisted_73 = {
  key: 1,
  src: _imports_7
};
const _hoisted_74 = {
  style: {
    "margin-left": "10px"
  }
};
const _hoisted_75 = {
  class: "box",
  style: {
    "height": "310px"
  }
};
const _hoisted_76 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "box_title"
}, "电瓶取出超时", -1));
const _hoisted_77 = {
  class: "box",
  style: {
    "height": "310px"
  }
};
const _hoisted_78 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "box_title"
}, "运维动态", -1));
const _hoisted_79 = {
  class: "box_content"
};
const _hoisted_80 = {
  style: {
    "margin-left": "12px"
  }
};
const _hoisted_81 = {
  style: {
    "text-align": "right",
    "color": "#BFBFBF",
    "margin-right": "12px"
  }
};
const _hoisted_82 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1));
const _hoisted_83 = {
  style: {
    "margin-top": "-20px",
    "margin-bottom": "20px"
  }
};
const _hoisted_84 = {
  class: "functionList"
};
const _hoisted_85 = ["onClick"];
const _hoisted_86 = {
  class: "functionList_center"
};
const _hoisted_87 = ["onClick"];
const _hoisted_88 = ["onClick"];
const _hoisted_89 = ["onClick"];
const _hoisted_90 = {
  class: "functionList_r"
};
const _hoisted_91 = ["onClick"];
const _hoisted_92 = ["onClick"];
const _hoisted_93 = {
  class: "footerBox"
};
const _hoisted_94 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_statistic = _resolveComponent("el-statistic");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_table = _resolveComponent("el-table");
  const _component_vue3_seamless_scroll = _resolveComponent("vue3-seamless-scroll");
  const _component_Search = _resolveComponent("Search");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_scrollbar = _resolveComponent("el-scrollbar");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    gutter: 10
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 16
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", null, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", {
        style: {
          "cursor": "pointer"
        },
        onClick: _cache[0] || (_cache[0] = (...args) => $options.openDialog && $options.openDialog(...args))
      }, "管理常用功能")])])])]), _createElementVNode("div", null, [_createVNode(_component_el_row, {
        justify: 'start'
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.anyList, (item, index) => {
          return _openBlock(), _createBlock(_component_el_col, {
            key: index,
            span: 3
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: "box_so",
              onClick: $event => $options.goPermission(item)
            }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("img", {
              src: item.img
            }, null, 8, _hoisted_9)]), _createElementVNode("div", null, _toDisplayString(item.name), 1)], 8, _hoisted_7)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      })])])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", null, [_createVNode(_component_el_row, {
        justify: 'space-between'
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 3
        }, {
          default: _withCtx(() => [_hoisted_11]),
          _: 1
        })]),
        _: 1
      })]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", null, [_createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = (...args) => $options.goTaskList && $options.goTaskList(...args)),
        class: "box_img"
      }, [_hoisted_13, _createTextVNode(" 任务池 (" + _toDisplayString($data.taskCount) + ") ", 1)])]), _createElementVNode("div", null, [_createElementVNode("div", {
        onClick: _cache[2] || (_cache[2] = (...args) => $options.goMyTask && $options.goMyTask(...args)),
        style: {
          "margin-right": "50px"
        },
        class: "box_img"
      }, [_hoisted_14, _createTextVNode(" 处理中 (" + _toDisplayString($data.myTask) + ") ", 1)])])])])])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    gutter: 10
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 24
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("div", null, [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", null, [_createVNode(_component_el_select, {
        modelValue: $data.date,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.date = $event),
        style: {
          "width": "60px"
        },
        size: "small",
        onChange: $options.getRide
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.options, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item,
            label: item,
            value: item
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue", "onChange"])])])])])]), _createVNode(_component_el_row, {
        justify: 'space-between'
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 4
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_19, [_createVNode(_component_el_statistic, {
            precision: 2,
            value: $data.rideFee.fee
          }, {
            title: _withCtx(() => [_hoisted_20]),
            _: 1
          }, 8, ["value"]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [$data.date === '今日' ? (_openBlock(), _createElementBlock("span", _hoisted_23, "上一日")) : _createCommentVNode("", true), $data.date === '昨日' ? (_openBlock(), _createElementBlock("span", _hoisted_24, "前一日")) : _createCommentVNode("", true), $data.date === '本月' ? (_openBlock(), _createElementBlock("span", _hoisted_25, "上一月")) : _createCommentVNode("", true), _createElementVNode("span", {
            class: _normalizeClass($data.rideFee.trend === 'rise' ? 'green' : 'red')
          }, [_createVNode(_component_el_statistic, {
            precision: 2,
            value: $data.rideFee.beforeFee,
            style: {
              "margin-right": "10px"
            }
          }, null, 8, ["value"]), $data.rideFee.trend === 'rise' ? (_openBlock(), _createElementBlock("img", _hoisted_26)) : _createCommentVNode("", true), $data.rideFee.trend === 'fall' ? (_openBlock(), _createElementBlock("img", _hoisted_27)) : _createCommentVNode("", true), _createVNode(_component_el_statistic, {
            style: {
              "margin-left": "2px"
            },
            precision: 2,
            value: $data.rideFee.change
          }, null, 8, ["value"])], 2)])])])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 4
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_28, [_createVNode(_component_el_statistic, {
            value: $data.rideCount.count
          }, {
            title: _withCtx(() => [_hoisted_29]),
            _: 1
          }, 8, ["value"]), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [$data.date === '今日' ? (_openBlock(), _createElementBlock("span", _hoisted_32, "上一日")) : _createCommentVNode("", true), $data.date === '昨日' ? (_openBlock(), _createElementBlock("span", _hoisted_33, "前一日")) : _createCommentVNode("", true), $data.date === '本月' ? (_openBlock(), _createElementBlock("span", _hoisted_34, "上一月")) : _createCommentVNode("", true), _createElementVNode("span", {
            class: _normalizeClass($data.rideCount.trend === 'rise' ? 'green' : 'red')
          }, [_createVNode(_component_el_statistic, {
            value: $data.rideCount.beforeCount,
            style: {
              "margin-right": "15px"
            }
          }, null, 8, ["value"]), $data.rideCount.trend === 'rise' ? (_openBlock(), _createElementBlock("img", _hoisted_35)) : _createCommentVNode("", true), $data.rideCount.trend === 'fall' ? (_openBlock(), _createElementBlock("img", _hoisted_36)) : _createCommentVNode("", true), _createVNode(_component_el_statistic, {
            style: {
              "margin-left": "2px"
            },
            value: $data.rideCount.change
          }, null, 8, ["value"])], 2)])])])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 4
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_37, [_createVNode(_component_el_statistic, {
            value: $data.rideUser.count
          }, {
            title: _withCtx(() => [_hoisted_38]),
            _: 1
          }, 8, ["value"]), _createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [$data.date === '今日' ? (_openBlock(), _createElementBlock("span", _hoisted_41, "上一日")) : _createCommentVNode("", true), $data.date === '昨日' ? (_openBlock(), _createElementBlock("span", _hoisted_42, "前一日")) : _createCommentVNode("", true), $data.date === '本月' ? (_openBlock(), _createElementBlock("span", _hoisted_43, "上一月")) : _createCommentVNode("", true), _createElementVNode("span", {
            class: _normalizeClass($data.rideUser.trend === 'rise' ? 'green' : 'red')
          }, [_createVNode(_component_el_statistic, {
            value: $data.rideUser.beforeCount,
            style: {
              "margin-right": "15px"
            }
          }, null, 8, ["value"]), $data.rideUser.trend === 'rise' ? (_openBlock(), _createElementBlock("img", _hoisted_44)) : _createCommentVNode("", true), $data.rideUser.trend === 'fall' ? (_openBlock(), _createElementBlock("img", _hoisted_45)) : _createCommentVNode("", true), _createVNode(_component_el_statistic, {
            style: {
              "margin-left": "2px"
            },
            value: $data.rideUser.change
          }, null, 8, ["value"])], 2)])])])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 4
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_46, [_createVNode(_component_el_statistic, {
            value: $data.ywCount.count
          }, {
            title: _withCtx(() => [_hoisted_47]),
            _: 1
          }, 8, ["value"]), _createElementVNode("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, [$data.date === '今日' ? (_openBlock(), _createElementBlock("span", _hoisted_50, "上一日")) : _createCommentVNode("", true), $data.date === '昨日' ? (_openBlock(), _createElementBlock("span", _hoisted_51, "前一日")) : _createCommentVNode("", true), $data.date === '本月' ? (_openBlock(), _createElementBlock("span", _hoisted_52, "上一月")) : _createCommentVNode("", true), _createElementVNode("span", {
            class: _normalizeClass($data.ywCount.trend === 'rise' ? 'green' : 'red')
          }, [_createVNode(_component_el_statistic, {
            value: $data.ywCount.beforeCount,
            style: {
              "margin-right": "15px"
            }
          }, null, 8, ["value"]), $data.ywCount.trend === 'rise' ? (_openBlock(), _createElementBlock("img", _hoisted_53)) : _createCommentVNode("", true), $data.ywCount.trend === 'fall' ? (_openBlock(), _createElementBlock("img", _hoisted_54)) : _createCommentVNode("", true), _createVNode(_component_el_statistic, {
            style: {
              "margin-left": "2px"
            },
            value: $data.ywCount.change
          }, null, 8, ["value"])], 2)])])])]),
          _: 1
        })]),
        _: 1
      })])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    gutter: 10
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 16
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_55, [_createElementVNode("div", null, [_createVNode(_component_el_row, {
        justify: 'space-between'
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 4
        }, {
          default: _withCtx(() => [_hoisted_56]),
          _: 1
        })]),
        _: 1
      })]), _createElementVNode("div", null, [_createVNode(_component_el_table, {
        data: $data.tableData,
        style: {
          "width": "100%"
        },
        height: "240",
        border: false,
        stripe: false
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "id",
          label: "任务编码"
        }), _createVNode(_component_el_table_column, {
          prop: "taskType",
          label: "任务类型"
        }), _createVNode(_component_el_table_column, {
          prop: "assignee",
          label: "处理人"
        }), _createVNode(_component_el_table_column, {
          prop: "taskStatus",
          label: "任务状态"
        }, {
          default: _withCtx(scope => [_createElementVNode("div", _hoisted_57, [scope.row.taskStatus === 3 ? (_openBlock(), _createElementBlock("img", _hoisted_58)) : _createCommentVNode("", true), scope.row.taskStatus === 1 ? (_openBlock(), _createElementBlock("img", _hoisted_59)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_60, _toDisplayString(scope.row.taskStatus === 1 ? '待接单' : '待完成'), 1)])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "createTime",
          label: "创建时间"
        }), _createVNode(_component_el_table_column, {
          prop: "overTime",
          label: "超时时长"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString($options.minTime(scope.row.overTime)), 1)]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])])])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_61, [_createElementVNode("div", null, [_createVNode(_component_el_row, {
        justify: 'space-between'
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 4
        }, {
          default: _withCtx(() => [_hoisted_62]),
          _: 1
        })]),
        _: 1
      })]), _hoisted_63, _createElementVNode("div", null, [_createElementVNode("div", _hoisted_64, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_65, [_hoisted_66, _createTextVNode(" 合计：" + _toDisplayString($data.yunUserList.total) + "人 ", 1)])]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_67, [_hoisted_68, _createTextVNode(" 在线(" + _toDisplayString($data.yunUserList.online) + "人) ", 1)])]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_69, [_hoisted_70, _createTextVNode(" 离线(" + _toDisplayString($data.yunUserList.offline) + "人) ", 1)])])])]), _createElementVNode("div", null, [_createVNode(_component_el_table, {
        data: $data.yunList,
        style: {
          "width": "100%"
        },
        height: "195",
        "default-sort": {
          prop: 'onlineStatus',
          order: 'ascending'
        },
        border: false,
        stripe: false
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "name",
          label: "人员名称"
        }), _createVNode(_component_el_table_column, {
          prop: "onlineStatus",
          label: "当前状态"
        }, {
          default: _withCtx(scope => [_createElementVNode("div", _hoisted_71, [scope.row.onlineStatus === 0 ? (_openBlock(), _createElementBlock("img", _hoisted_72)) : _createCommentVNode("", true), scope.row.onlineStatus === 1 ? (_openBlock(), _createElementBlock("img", _hoisted_73)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_74, _toDisplayString(scope.row.onlineStatus === 0 ? '在线' : '离线'), 1)])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "workTime",
          label: "今日在线时长"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString($options.minTime(scope.row.workTime)), 1)]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])])])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    gutter: 10
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 16
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_75, [_createElementVNode("div", null, [_createVNode(_component_el_row, {
        justify: 'space-between'
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 4
        }, {
          default: _withCtx(() => [_hoisted_76]),
          _: 1
        })]),
        _: 1
      })]), _createElementVNode("div", null, [_createVNode(_component_el_table, {
        data: $data.overTimeBatteryList,
        style: {
          "width": "100%"
        },
        height: "240",
        border: false,
        stripe: false
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "id",
          label: "电瓶编码"
        }), _createVNode(_component_el_table_column, {
          prop: "position",
          label: "最近所在位置"
        }), _createVNode(_component_el_table_column, {
          prop: "createTime",
          label: "取出时间"
        }), _createVNode(_component_el_table_column, {
          prop: "overTime",
          label: "超出时长"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString($options.minTime(scope.row.overTime)), 1)]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])])])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_77, [_createElementVNode("div", null, [_createVNode(_component_el_row, {
        justify: 'space-between'
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 4
        }, {
          default: _withCtx(() => [_hoisted_78]),
          _: 1
        })]),
        _: 1
      })]), _createElementVNode("div", _hoisted_79, [_createVNode(_component_vue3_seamless_scroll, {
        list: $data.operationList,
        class: "scroll",
        step: 0.5
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.operationList, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "ywbox",
            key: index
          }, [_createElementVNode("div", _hoisted_80, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_81, _toDisplayString($options.min(item.time)), 1)]);
        }), 128))]),
        _: 1
      }, 8, ["list", "step"])]), _hoisted_82])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_dialog, {
    modelValue: $data.centerDialogVisible,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.centerDialogVisible = $event),
    title: "管理常用功能",
    width: "800",
    "destroy-on-close": "",
    "align-center": "",
    onClose: $options.close
  }, {
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_93, [_createElementVNode("div", null, "已添加（" + _toDisplayString($data.permissionList.length) + "个）", 1)]), _createElementVNode("div", _hoisted_94, [_createVNode(_component_el_button, {
      onClick: _cache[5] || (_cache[5] = $event => $data.centerDialogVisible = false)
    }, {
      default: _withCtx(() => [_createTextVNode("取消")]),
      _: 1
    }), _createVNode(_component_el_button, {
      type: "primary",
      onClick: $options.save
    }, {
      default: _withCtx(() => [_createTextVNode(" 确定 ")]),
      _: 1
    }, 8, ["onClick"])])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_83, [_createVNode(_component_el_input, {
      modelValue: $data.input,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.input = $event),
      style: {
        "max-width": "100%"
      },
      placeholder: "请输入内容搜索",
      onInput: $options.queryByLike
    }, {
      prepend: _withCtx(() => [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_Search)]),
        _: 1
      })]),
      _: 1
    }, 8, ["modelValue", "onInput"])]), _createElementVNode("div", null, [_createVNode(_component_el_row, {
      justify: 'space-between'
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 5
      }, {
        default: _withCtx(() => [_createVNode(_component_el_scrollbar, {
          height: "300px"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_84, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.functionList, (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              class: _normalizeClass($data.pIndex === index ? 'bg' : ''),
              key: index,
              onClick: $event => $options.changePbtn(index, item.id)
            }, _toDisplayString(item.name), 11, _hoisted_85);
          }), 128))])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 9
      }, {
        default: _withCtx(() => [_createVNode(_component_el_scrollbar, {
          height: "300px"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_86, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.functionListSon, (item, index) => {
            return _openBlock(), _createBlock(_component_el_row, {
              justify: 'space-between',
              key: index
            }, {
              default: _withCtx(() => [_createVNode(_component_el_col, {
                span: 6
              }, {
                default: _withCtx(() => [_createElementVNode("div", {
                  class: _normalizeClass(item.isDown && $data.sIndex === index ? 'bg divBtn' : 'divBtn'),
                  onClick: $event => $options.changeSbtn(index, item.id)
                }, _toDisplayString(item.name), 11, _hoisted_87)]),
                _: 2
              }, 1024), !item.isDown ? (_openBlock(), _createBlock(_component_el_col, {
                key: 0,
                span: 8
              }, {
                default: _withCtx(() => [!item.isCommon ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "btn btnC",
                  style: {
                    "margin-top": "3px"
                  },
                  onClick: $event => $options.add(item, index, 2)
                }, " 添加 ", 8, _hoisted_88)) : _createCommentVNode("", true), item.isCommon ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "btn",
                  style: {
                    "margin-top": "3px"
                  },
                  onClick: $event => $options.remove(item, index, 2)
                }, " 移除 ", 8, _hoisted_89)) : _createCommentVNode("", true)]),
                _: 2
              }, 1024)) : _createCommentVNode("", true)]),
              _: 2
            }, 1024);
          }), 128))])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 10
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_90, [_createVNode(_component_el_scrollbar, {
          height: "300px"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.functionListSonChild, (item, index) => {
            return _openBlock(), _createBlock(_component_el_row, {
              key: index,
              justify: 'space-between'
            }, {
              default: _withCtx(() => [_createVNode(_component_el_col, {
                span: 8
              }, {
                default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(item.name), 1)]),
                _: 2
              }, 1024), !item.isDown ? (_openBlock(), _createBlock(_component_el_col, {
                key: 0,
                span: 8
              }, {
                default: _withCtx(() => [!item.isCommon ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "btn btnC",
                  onClick: $event => $options.add(item, index, 3)
                }, " 添加 ", 8, _hoisted_91)) : _createCommentVNode("", true), item.isCommon ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "btn",
                  onClick: $event => $options.remove(item, index, 3)
                }, " 移除 ", 8, _hoisted_92)) : _createCommentVNode("", true)]),
                _: 2
              }, 1024)) : _createCommentVNode("", true)]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 1
        })])]),
        _: 1
      })]),
      _: 1
    })])]),
    _: 1
  }, 8, ["modelValue", "onClose"])]);
}